import {
    GET_ALL_CARD_DETAILS,
    GET_CARD_DETAILS,
    GET_ALL_PAYMENT_METHOD_CARD_DETAILS,
    GET_PAYMENT_METHOD_CARD_DETAILS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './cardTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_CARD_DETAILS:
            return {
                ...state,
                get_all_card_details: action.payload,
            }
        case GET_CARD_DETAILS:
            return {
                ...state,
                get_card_details: action.payload,
            }
        case GET_ALL_PAYMENT_METHOD_CARD_DETAILS:
            return {
                ...state,
                get_all_payment_method_card_details: action.payload,
            }
        case GET_PAYMENT_METHOD_CARD_DETAILS:
            return {
                ...state,
                get_payment_method_card_details: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
